<template>
  <WebccSelect
    v-cloak
    v-model="model"
    icon="attributes/feature-pax"
    :label
    :disabled
    :options
    :checkmarks="!valid"
    :valid
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: number
  max: number
  prefix:
    | 'www.components.views.details.Sidebar.'
    | 'www.components.views.details.MobileBar.'
  label?: string
  disabled?: boolean
}>()

const trPrefix = props.prefix

const { t } = useI18n()

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): number
}>()

const model = computed({
  get() {
    return props.modelValue || props.max
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

const valid = computed(() => model.value <= props.max)

const options = computed(() => {
  return Array.from({ length: props.max }, (_, i) => i + 1)
    .concat(!valid.value ? [model.value] : []) // add invalid value to display it anyways
    .map((value) => ({ label: t(`${trPrefix}person_s`, value), value }))
})
</script>
